import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationChallengeLongestActivityNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.407 4.193C.924 3.777 4.654 1 12 1s11.076 2.777 11.593 3.193c.275.221.407.541.407.852V13c0 3.965-3.026 6.685-5.766 8.35-2.792 1.698-5.639 2.521-5.941 2.607a1.08 1.08 0 01-.586 0c-.302-.086-3.149-.909-5.941-2.606C3.026 19.685 0 16.965 0 13V5.046c0-.298.123-.624.407-.853zM2 5.506V13c0 1.975 1.05 3.637 2.563 5H11.5a1.5 1.5 0 000-3h-4a3.5 3.5 0 110-7H16l-1.6-1.2 1.2-1.6 4 3a1 1 0 010 1.6l-4 3-1.2-1.6L16 10H7.5a1.5 1.5 0 000 3h4a3.5 3.5 0 110 7H7.42A24.793 24.793 0 0012 21.958c.757-.233 3.006-.985 5.195-2.316C19.808 18.053 22 15.852 22 13V5.506C20.981 4.82 17.735 3 12 3S3.019 4.82 2 5.506z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationChallengeLongestActivityNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationChallengeLongestActivityNormalSmall;
